
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { useBreakpoints } from '@vueuse/core';

export default defineComponent({
  setup() {
    const breakpoints = useBreakpoints({
      mobile: 640,
    });

    const isMobile = breakpoints.smaller('mobile');

    const isOpen = ref(false);

    const toggle = () => {
      isOpen.value = !isOpen.value;
    };

    return {
      isOpen,
      toggle,
      isMobile,
    };
  },
});
